import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {getCookie} from '~/shared/utils/cookie';

const backendUrl = (import.meta.env.VITE_BACKEND_URL || import.meta.env.VITE_API_URL || '').replace(/\/+$/, '');
const apiBaseUrl = import.meta.env.DEV ? '/api' : `${backendUrl}/api`;
export const rtkQueryApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl,
    prepareHeaders: headers => {
      const token = getCookie('auth-token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept', `application/json`);

      return headers;
    },
  }),
  endpoints: () => ({}),
});
